import { render, staticRenderFns } from "./MenuBarGpt.vue?vue&type=template&id=b0adbd7e&scoped=true"
import script from "./MenuBarGpt.vue?vue&type=script&lang=js"
export * from "./MenuBarGpt.vue?vue&type=script&lang=js"
import style0 from "./MenuBarGpt.vue?vue&type=style&index=0&id=b0adbd7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0adbd7e",
  null
  
)

export default component.exports